import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const PaymentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background-color: ${COLORS.bgSubtle};
`

export const ProgressBarSection = styled.div`
  flex: 0 0 auto;
  background-color: ${COLORS.bgWhite};
`

export const PaymentScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 16px;
`

export const PaymentBottomBar = styled.div`
  flex: 0 0 auto;
  padding: 12px 24px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgSubtle};
`
